import React from "react"

import { Action } from "shared/types/Action"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { Tooltip } from "shared/ui/tooltip/Tooltip"

interface ActionsProps {
  actions: Action[]
  autoFocus?: boolean
  isIconOnly?: boolean
}

export const ProjectPageSidebarActions = React.memo(
  ({ actions, autoFocus, isIconOnly = true }: ActionsProps) => {
    if (!actions.length) return null
    return (
      <Tooltip.Provider>
        <div role="group" className="project-page-sidebar__actions">
          {actions.map((action, index) => (
            <Tooltip
              key={action.id}
              content={action.label}
              placement="top"
              disabled={!isIconOnly}
            >
              <Button
                {...action}
                isIconOnly={action.isIconOnly ?? isIconOnly}
                variant={ButtonVariant.TERTIARY}
                autoFocus={autoFocus && index === 0}
              />
            </Tooltip>
          ))}
        </div>
      </Tooltip.Provider>
    )
  }
)
ProjectPageSidebarActions.displayName = "ProjectPageSidebarActions"
